// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.account-dropdown-title {
    box-shadow: none;
    background-color: transparent;
    padding: 20px;
    position: fixed;
    width: 20px;
    height: 20px;
    right: 20px;
    top: 17px;
  }

    .account-dropdown-title-account {
      font-family: avenir;
      padding-left: 20px;
      font-size: 14px;
    }
  .account-dropdown-wrapper {
    z-index: 2;
    right: 0;
  }
  .account-dropdown-buttons-wrapper {
    position: fixed;
    right: 5px;
    top: 60px;
    border-radius: 6px;
    box-shadow: var(--box-shadow-0);
    padding-bottom: 10px;
    background-color: var(--bg-color-0);
  }
  .account-dropdown-buttons {
    cursor: pointer;
    text-align: left;
    padding: 0;
    font-family: avenir;
    height: 50px;
    width: 265px;
    box-shadow: none;
    border: none;
    font-size: 14px;
    display: flex;
    flex-direction: row;
    background-color: var(--bg-color-0);
  }
  .account-dropdown-buttons > p {
      padding-left: 35px;
    }
  .account-dropdown-buttons--selected {
      color: var(--color-0);
      background-color: var(--bg-color-selected-0);
    }
  .account-dropdown-icon {
    cursor: pointer;
    width: 9px;
    position: fixed;
    right: 30px;
    top: 20px;
  }
  .account-dropdown-icon--open {
      transform: rotate(180deg);
      width: 15px;
      position: fixed;
      right: 30px;
      top: 18px;
    }

.clickaway {
  z-index: -1;
  position: fixed;
  inset: 0;
  cursor: ;
}
`, "",{"version":3,"sources":["webpack://./app/components/AccountDropdown/style.css"],"names":[],"mappings":"AACE;IACE,gBAAgB;IAChB,6BAA6B;IAC7B,aAAa;IACb,eAAe;IACf,WAAW;IACX,YAAY;IACZ,WAAW;IACX,SAAS;EAOX;;IALE;MACE,mBAAmB;MACnB,kBAAkB;MAClB,eAAe;IACjB;EAGF;IACE,UAAU;IACV,QAAQ;EACV;EAEA;IACE,eAAe;IACf,UAAU;IACV,SAAS;IACT,kBAAkB;IAClB,+BAA+B;IAC/B,oBAAoB;IACpB,mCAAmC;EACrC;EAEA;IACE,eAAe;IACf,gBAAgB;IAChB,UAAU;IACV,mBAAmB;IACnB,YAAY;IACZ,YAAY;IACZ,gBAAgB;IAChB,YAAY;IACZ,eAAe;IACf,aAAa;IACb,mBAAmB;IACnB,mCAAmC;EAUrC;EARE;MACE,kBAAkB;IACpB;EAEA;MACE,qBAAqB;MACrB,4CAA4C;IAC9C;EAGF;IACE,eAAe;IACf,UAAU;IACV,eAAe;IACf,WAAW;IACX,SAAS;EASX;EAPE;MACE,yBAAyB;MACzB,WAAW;MACX,eAAe;MACf,WAAW;MACX,SAAS;IACX;;AAIJ;EACE,WAAW;EACX,eAAe;EACf,QAAQ;EACR,QAAQ;AACV","sourcesContent":[".account-dropdown {\n  &-title {\n    box-shadow: none;\n    background-color: transparent;\n    padding: 20px;\n    position: fixed;\n    width: 20px;\n    height: 20px;\n    right: 20px;\n    top: 17px;\n\n    &-account {\n      font-family: avenir;\n      padding-left: 20px;\n      font-size: 14px;\n    }\n  }\n\n  &-wrapper {\n    z-index: 2;\n    right: 0;\n  }\n\n  &-buttons-wrapper {\n    position: fixed;\n    right: 5px;\n    top: 60px;\n    border-radius: 6px;\n    box-shadow: var(--box-shadow-0);\n    padding-bottom: 10px;\n    background-color: var(--bg-color-0);\n  }\n\n  &-buttons {\n    cursor: pointer;\n    text-align: left;\n    padding: 0;\n    font-family: avenir;\n    height: 50px;\n    width: 265px;\n    box-shadow: none;\n    border: none;\n    font-size: 14px;\n    display: flex;\n    flex-direction: row;\n    background-color: var(--bg-color-0);\n\n    & > p {\n      padding-left: 35px;\n    }\n\n    &--selected {\n      color: var(--color-0);\n      background-color: var(--bg-color-selected-0);\n    }\n  }\n\n  &-icon {\n    cursor: pointer;\n    width: 9px;\n    position: fixed;\n    right: 30px;\n    top: 20px;\n\n    &--open {\n      transform: rotate(180deg);\n      width: 15px;\n      position: fixed;\n      right: 30px;\n      top: 18px;\n    }\n  }\n}\n\n.clickaway {\n  z-index: -1;\n  position: fixed;\n  inset: 0;\n  cursor: ;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
